import { ExtraInfoFields } from '../../../shared/interfaces';
import { getDeviceExtraInfo } from '../../../shared/db/extra-info-db';
import { getExtraInfoKeyByName } from '../../../utils';

export type PointAddress = {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
};

export const formatAddress = (address?: PointAddress | null): string => {
    const addressEntries: string[] = [];

    if (address?.street) {
        addressEntries.push(address.street.replace(/\S*\+[^ ]*/g, ''));
    }
    if (address?.city) addressEntries.push(address.city);
    if (address?.state) addressEntries.push(address.state);
    if (address?.zip) addressEntries.push(address.zip);

    return addressEntries
        .map(entry => entry.replace(/US/gi, ''))
        .filter(entry => entry !== '')
        .join(', ');
};

export const getFormattedMakeModel = async (deviceId: string): Promise<string> => {
    const keys = await Promise.all([
        getExtraInfoKeyByName(ExtraInfoFields.YEAR),
        getExtraInfoKeyByName(ExtraInfoFields.MAKE),
        getExtraInfoKeyByName(ExtraInfoFields.MODEL)
    ]);

    const values = await Promise.all(
        keys.map(async (key) => {
            const extraInfo = await getDeviceExtraInfo(deviceId, key);
            return extraInfo;
        })
    );

    type ExtraInfoText = { text: string };

    const formatted = values
        .map((item) => {
            if (typeof item === 'string') {
                return item;
            }
            if (
                item &&
                typeof item === 'object' &&
                'text' in item &&
                typeof (item as ExtraInfoText).text === 'string'
            ) {
                return (item as ExtraInfoText).text;
            }
            return null;
        })
        .filter((e): e is string => e !== null && e.trim() !== '')
        .join(' ');

    return formatted.trim();
};

export const isMoreThan30DaysAgo = (date: Date): boolean => {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    const timestampThirtyDaysAgo = Date.now() - thirtyDaysInMs;

    return timestampThirtyDaysAgo > date.getTime();
};